import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Application } from '../shared/models/header/application.interface';
import { QuickLinks } from '../shared/models/header/quicklinks.interface';
import { EmpEvent } from '../shared/models/setups/roles/roleEvent.interface';
import { Menu } from '../shared/models/sidebar/sidebar.interface';
import { CostCenters } from '../shared/models/UserMapping/UserMapping.interface';
import { isQuickLinks, LoadQuickLinksSuccess, LoadRoleMenusSuccess, LoadUserApplications, LoadUserApplicationsSuccess, LoadUserCostCentersSuccess, LoadUserEventsSuccess } from './userMap.action';

export const UserMappingFeatureKey = 'UserMapping';

export interface UserMappingState {
    CostCenters: CostCenters[];
    Applications: Application[];
    RoleMenus: Menu[];
    Events: EmpEvent[];
    QuickLinks: QuickLinks[];
    isQuickLinks: boolean;
    errors: string;
}

const InitialState: UserMappingState = {
    CostCenters: [],
    Applications: [],
    RoleMenus: [],
    Events: [],
    QuickLinks: [],
    isQuickLinks: false,
    errors: '',
};


export const UserMappingReducer = createReducer(
    InitialState,
    // tslint:disable-next-line: no-shadowed-variable
    on(LoadUserCostCentersSuccess, (state, { CostCenters }) => ({
        ...state,
        CostCenters,
        errors: '',
    })),
    on(LoadUserApplicationsSuccess, (state, { Applications }) => ({
        ...state,
        Applications,
        errors: '',
    })),
    // tslint:disable-next-line: no-shadowed-variable
    on(LoadQuickLinksSuccess, (state, { QuickLinks }) => ({
        ...state,
        QuickLinks,
        errors: '',
    })),
    on(isQuickLinks, (state, { status }) => ({
        ...state,
        isQuickLinks: status,
        errors: '',
    })),
    on(LoadRoleMenusSuccess, (state, { RoleMenus }) => ({
        ...state,
        RoleMenus: state.RoleMenus.concat(RoleMenus),
        errors: '',
    })),
    on(LoadUserEventsSuccess, (state, { Events }) => ({
        ...state,
        Events,
        errors: '',
    })),
    );


const UserMappingSelector = createFeatureSelector<UserMappingState>(UserMappingFeatureKey);
export const GetUserApplications = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.Applications;
    }
);

export const GetUserCostCenters = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.CostCenters;
    }
);

export const getApplication = createSelector(
    UserMappingSelector,
    (state: UserMappingState, props) => {
        return state.Applications.filter((res) => res.app_link === props.link);
    }
);

export const GetRoleMenus = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.RoleMenus;
    }
);

export const AppMenu = createSelector(
    UserMappingSelector,
    (state: UserMappingState, props) => {
        return state.RoleMenus.filter((data) => data.app_link === props.path);
    }
);

export const GetEvents = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.Events;
    }
);

export const GetQuickLinks = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.QuickLinks;
    }
);

export const QuickLinksStatus = createSelector(
    UserMappingSelector,
    (state: UserMappingState) => {
        return state.isQuickLinks;
    }
);





// tslint:disable-next-line: typedef
export function reducer(state: UserMappingState | undefined, action: Action) {
    return UserMappingReducer(state, action);
}

